import { MenuType } from "../enums";

export interface IMenuModel {
    id: number;
    mainPage: string;
    subPage: string;
    category: string;
    url: string;
    count: number;
    priority: number;
    generalClasses: string;
    iconClasses: string;
    menuTypeId: MenuType;
    encounterKey: string;
    isEncounterCompleted: boolean;
    encounterCompletedCount: number;
    isObEncounterCompleted: boolean;
    isPediatricEncounterCompleted: boolean;
    displayName: string;
    activeRoute: string;
    isGynEncounterCompleted: boolean;
    hasMarker?: boolean;
    isHovering?: boolean;
    categoryMenus: Array<ICategoryMenuModel>;
    isDietEncounterCompleted: boolean;
    isPhysiotherapyEncounterCompleted: boolean;
    isGeneticEncounterCompleted: boolean;
}

export interface ICategoryMenuModel {
    id: number;
    priority: number;
    url: string;
    subPage: string;
    displayName: string;
    iconClasses: string;
    isEncounterCompleted: boolean;
}

export interface IMenuOverAllModel {
    isFullAccess: boolean;
    menus: Array<IMenuModel>;
    menuButtonCodes: Array<string>;
}







